import React, { useState } from 'react';
import { IconButton, Typography, COLORS } from 'pvs-design-system';
import { Box } from '@mui/material';

const RoleListTooltip: React.FC = () => {
  const [visible, setVisible] = useState(false);

  return (
    <span style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', marginLeft: 4, verticalAlign: 'middle' }}>
      <Box
        component="span"
        role="button"
        tabIndex={0}
        aria-label="Role list help"
        aria-expanded={visible}
        onClick={() => setVisible((p) => !p)}
        onKeyDown={(e: React.KeyboardEvent) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setVisible((p) => !p); } }}
        sx={{ cursor: 'pointer', display: 'inline-flex', lineHeight: 1, '&:hover svg circle': { fill: COLORS.purple[200] } }}
      >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <circle cx="8" cy="8" r="7.25" stroke={COLORS.purple[700]} strokeWidth="1.5" fill={COLORS.purple[100]} />
          <text x="8" y="12" textAnchor="middle" fill={COLORS.purple[700]} fontSize="10" fontWeight="700">?</text>
        </svg>
      </Box>

      {visible && (
        <>
          <Box style={{ position: 'fixed', inset: 0, zIndex: 1500 }} onClick={() => setVisible(false)} />
          <Box
            style={{
              position: 'absolute', left: '50%', bottom: 'calc(100% + 8px)',
              transform: 'translateX(-50%)', zIndex: 1600, width: 280,
              background: '#fff', borderRadius: 12,
              boxShadow: '0 12px 40px rgba(0,0,0,0.15), 0 1px 3px rgba(0,0,0,0.08)',
              overflow: 'hidden',
            }}
            role="dialog"
            aria-label="Role List"
          >
            {/* Header */}
            <Box style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              padding: '12px 16px',
              borderBottom: `2px solid ${COLORS.purple[200]}`,
            }}>
              <Box style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <Box style={{
                  width: 24, height: 24, borderRadius: '50%',
                  background: COLORS.purple[100],
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>
                  <svg width="12" height="12" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                    <circle cx="8" cy="8" r="7" stroke={COLORS.purple[700]} strokeWidth="1.5" />
                    <text x="8" y="12" textAnchor="middle" fill={COLORS.purple[700]} fontSize="10" fontWeight="700">?</text>
                  </svg>
                </Box>
                <Typography variant="label-md" style={{ color: COLORS.gray[900] }}>Role List</Typography>
              </Box>
              <IconButton
                size="small"
                aria-label="Close"
                onClick={() => setVisible(false)}
                sx={{
                  width: 24, height: 24,
                  color: COLORS.gray[400],
                  '&:hover': { color: COLORS.gray[700], bgcolor: COLORS.gray[100] },
                }}
              >
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" aria-hidden="true">
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </IconButton>
            </Box>

            {/* Body */}
            <Box style={{ padding: '12px 16px', background: COLORS.purple[100] }}>
              <Typography variant="p-sm" style={{ color: COLORS.gray[400], lineHeight: '20px', margin: 0 }}>
                Only roles which have been granted the{' '}
                <strong style={{ color: COLORS.gray[900] }}>LIBRARY_USE</strong> permission can be given access to
                library resources.
              </Typography>
            </Box>

            {/* Footer */}
            <Box style={{ padding: '8px 16px', borderTop: `1px solid ${COLORS.gray[200]}` }}>
              <Typography variant="p-sm" style={{ fontSize: 12, color: COLORS.gray[400], fontStyle: 'italic' }}>Library Resource Help</Typography>
            </Box>
          </Box>
        </>
      )}
    </span>
  );
};

export default RoleListTooltip;
